// 市政经营许可证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let business = get(state, 'currentContractorDetail.contractorInfo.docInfo.business', {})
  return {
    title: i18n.gettext('营业执照'),
    content: [
      {
        title: i18n.gettext('营业执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: business.licensePics
      }
    ]
  }
}
